import FileDownload from 'js-file-download'
import axios from 'axios'
import {
  SET_DOWNLOAD_POINTS_BOX_OPEN,
  DOWNLOAD_POINTS_PENDING,
  DOWNLOAD_POINTS_SUCCESS,
  DOWNLOAD_POINTS_FAILED,
  GET_POINT_VALUE_PENDING,
  GET_POINT_VALUE_SUCCESS,
  GET_POINT_VALUE_FAILED,
} from '../actionTypes'

import { downloadPoints } from '../../service/points.service'

export const setDownloadPointsBoxOpen = () => ({
  type: SET_DOWNLOAD_POINTS_BOX_OPEN,
})

export const downloadPointsPending = () => ({
  type: DOWNLOAD_POINTS_PENDING,
})

export const downloadPointsSuccess = () => ({
  type: DOWNLOAD_POINTS_SUCCESS,
})

export const downloadPointsFailed = () => ({
  type: DOWNLOAD_POINTS_FAILED,
})

export const downloadPointsAction = (coordinates, type) => async (dispatch) => {
  try {
    dispatch(downloadPointsPending())
    const response = await downloadPoints(coordinates, type)
    if (response) {
      FileDownload(response, `points_${new Date().getTime()}.geojson`)
      dispatch(downloadPointsSuccess())
    }
  } catch (error) {
    dispatch(downloadPointsFailed(error))
  }
}

export const getPointPending = () => ({
  type: GET_POINT_VALUE_PENDING,
})

export const getPointSuccess = (value) => ({
  type: GET_POINT_VALUE_SUCCESS,
  payload: value,
})

export const getPointFailed = (error) => ({
  type: GET_POINT_VALUE_FAILED,
  payload: error,
})

export const getPointAction = (url) => async (dispatch) => {
  try {
    dispatch(getPointPending())
    const response = await axios.get(url)
    if (response) {
      dispatch(getPointSuccess(response.data))
    }
  } catch (error) {
    dispatch(getPointFailed(error))
  }
}
